import {BaseComponent} from './BaseComponent';
import {Subscription} from 'rxjs';
import {AppService} from './app.service';
import {Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {VasatError, VasatModel} from 'vasat';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { OnInit, OnDestroy } from '@angular/core';
import { XsEventListenerInterface } from '../xs/interfaces/event-listener.interface';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { Constants } from './Constants';

export class AppBaseComponent extends BaseComponent implements OnInit, OnDestroy {

  debugAppBase:boolean = Constants.debug_off;

  constructor(protected service: AppService, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, public applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog);
    if ( this.debugAppBase ) { console.log ( '%c app.base.comp ['+this.debugMe+'] %c constructor', Constants._green, Constants._gray ); }
  }

  // ready / error functions to be overridden
  onReady() {}
  onError(e:Error) {}

  // overwrite ngOnInit() as we do also start with __xs_start(), but we delay the this.init() until after Vasat.service.onReady()
  ngOnInit() {
    
    if ( this.debugAppBase ) { console.log ( '%c app.base.comp ['+this.debugMe+'] %c ngOnInit()', Constants._green, Constants._gray ); }
    
    // set up unique identifiers and event handlers
    this.__xs_start();
    
    if (this.service.V.localSession()) {
      this.service.onReady().subscribe(
        s => {
          this.init();
          this.onReady();
        },
        e => {
          if (e instanceof VasatError) {
            // TODO
          }
          this.onError(e);
        })
    } else {
      // this.router.navigateByUrl(this.routes.AUTH + '?prevpage=' + this.router.routerState.snapshot.url)
      this.router.navigateByUrl(this.routes.AUTH)
    }
  }

  ngOnDestroy() {
    // call on mama to clean up subscriptions
    super.ngOnDestroy();
    if ( this.debugAppBase ) { console.log ( '%c app.base.comp ['+this.debugMe+'] %c ngOnDestroy()', Constants._green, Constants._gray ); }
    this.destroy();
  }


  // this doesn't seem to ever be used? (@alex)
  setProp<T extends VasatModel<T>>(model: T, propName: string, value?: boolean) {
    //console.log("ENTER prop: " + propName + " value: " + value)
    //console.log(JSON.stringify(model.props))
    // Initialize props if undefinned
    if (!model.props) model.props = {}
    model.props[propName] = value
    //console.log(JSON.stringify(model.props))
    this.loading = true
    model.saveObservable().subscribe(
      res => {
        this.loading = false
      },
      err => {
        this.loading = false
        this.openSnackBarError(err.status + ' ' + err.message)
      }
    )
  }

}
